<template>
  <v-container fluid>
    <v-sheet outlined class="mt-3">

      <v-tabs
        v-model="tab"
        background-color="#586776" dark
        next-icon="mdi-arrow-right-bold"
        prev-icon="mdi-arrow-left-bold"
        show-arrows
      >
        <v-tabs-slider color="orange"></v-tabs-slider>
          
        <template v-for="(tab, t) in tabs">
          <!-- tab  title -->

          <v-tab :key="t" :disabled=!tab.enabled>
            <span v-if="tab.enabled" class="white--text">{{ tab.name }}</span>
            <span v-else>{{ tab.name }}</span>
          </v-tab>
        
          <!-- custom content ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
          <!-- constraints -->
          <v-tab-item :key="t" v-if="tab.name == 'Constraints'">
              <FacilityConstraints></FacilityConstraints>
          </v-tab-item>
          <!-- programs -->
          <v-tab-item :key="t" v-if="tab.name == 'Programs'">
              <FacilityPrograms></FacilityPrograms>
          </v-tab-item>
          <!-- demand charges -->
          <v-tab-item :key="t" v-if="tab.name == 'Demand Charges'">
            <FacilityDemandCharges></FacilityDemandCharges>
          </v-tab-item>

        </template>

      </v-tabs>
    </v-sheet>
  </v-container>
</template>

<script>
import ConfigService from '@/services/ConfigService'
import { mapGetters, mapMutations } from 'vuex'
export default {
  name: 'FacilityConfig',
  data() {
    return {
      tab: null,
      tabs: [
        { name: 'Constraints', enabled: true },
        { name: 'Programs', enabled: true }
        // { name: 'Demand Charges', enabled: true }
      ],
      componentKey: 0,
      loaded: false,
      valid: false,
      factorRules: [
        v =>
          (v > 0 && v < 2) || 'Required.  Must be greater than 0, less than 2'
      ],
      ceilingRules: [
        v =>
          (v >= 0 && v < 100000) || 'Required.  Must be between 0 and 100,000'
      ],
      configTabs: [
        {
          name: 'Programs',
          color: '#ebeff5',
          type: 'CP',
          visible: true
        },
        {
          name: 'Gas',
          color: '#d6deea',
          type: 'GAS',
          visible: false
        },
        {
          name: 'Generation',
          color: '#c2cee0',
          type: 'GEN',
          visible: false
        },
        {
          name: 'Storage',
          color: '#adbdd6',
          type: 'STOR',
          visible: false
        },
        {
          name: 'Solar',
          color: '#99adcc',
          type: 'SUN',
          visible: false
        },
        {
          name: 'Wind',
          color: '#859dc1',
          type: 'SUN',
          visible: false
        }
        // 708cb7 5c7cad 476ba2 335b98
      ],
      saveErr: false,
      peakMode: '',
      peakModeManual: '',
      ncpCeiling: '',
      ncpCeilingSwitch: '',
      adjustFactor1cp: '',
      previousMinThres1cp: '',
      adjustFactor5cp: '',
      previousMinThres5cp: '',
      keys: null
    }
  },
  // watch: {
  //   ncpCeilingSwitch() {
  //     console.log("ncpCeilingSwitch", this.ncpCeilingSwitch)
  //   }
  // },
  computed: {
    ...mapGetters(['getFacilityId', 'getFacilityTimezone', 'hasProgram']),
    manualModeLabel() {
      if (this.peakModeManual) return 'ON'
      return 'OFF'
    },
    ncpCeilingLabel() {
      if (this.ncpCeilingSwitch) return 'SET'
      return 'NOT SET'
    }
  },
  created() {
    this.createKeyMap()
    this.getPeakConfig()
  },
  methods: {
    ...mapMutations(['SET_NCP_CEILING']),

    setNcpCeiling() {
      // if going from off to on, set 0 value to default
      if (this.ncpCeilingSwitch) {
        if (this.ncpCeiling === 0) {
          this.ncpCeiling = 4000
          this.$toast.info("Enabling NCP Ceiling, setting to default 4000 kW")
        }
      }
      this.componentKey += 1
    },
    createKeyMap() {
      this.keys = new Map([
        ['MODE', 'PEAK_DAY_FACILITY_' + this.getFacilityId + '_MODE'],
        ['MODE_TOGGLE', 'PEAK_DAY_FACILITY_' + this.getFacilityId + '_MANUAL'],
        ['CEILING', 'NCP_CEILING_FACILITY_' + this.getFacilityId],
        ['1CP_FUDGE', 'PEAK_DAY_5CP_UTIL_FUDGE_FACILITY_' + this.getFacilityId],
        ['1CP_THRESH', 'PEAK_DAY_5CP_UTIL_PERCENT_FACILITY_' + this.getFacilityId],
        ['5CP_FUDGE', 'PEAK_DAY_5CP_ISO_FUDGE_FACILITY_' + this.getFacilityId],
        ['5CP_THRESH', 'PEAK_DAY_5CP_ISO_PERCENT_FACILITY_' + this.getFacilityId]
      ])
    },
    async getPeakConfig() {
      try {
        const modePromise = this.getConfig(this.keys.get('MODE'))
        const manualPromise = this.getConfig(this.keys.get('MODE_TOGGLE'))
        const ceilingPromise = this.getConfig(this.keys.get('CEILING'))
        const adjustPromise1cp = this.getConfig(this.keys.get('1CP_FUDGE'))
        const thresPromise1cp = this.getConfig(this.keys.get('1CP_THRESH'))
        const adjustPromise5cp = this.getConfig(this.keys.get('5CP_FUDGE'))
        const thresPromise5cp = this.getConfig(this.keys.get('5CP_THRESH'))

        const [
          mode,
          manual,
          ceiling,
          adjust1cp,
          thresh1cp,
          adjust5cp,
          thresh5cp
        ] = await Promise.all([
          modePromise,
          manualPromise,
          ceilingPromise,
          adjustPromise1cp,
          thresPromise1cp,
          adjustPromise5cp,
          thresPromise5cp
        ])

        // **
        if (this.hasProgram('NCP')) {
          if (mode == null) {
            this.postConfig(this.keys.get('MODE'), 'manual')
            this.peakMode = 'manual'
          } else {
            this.peakMode = mode
          }

          if (manual == null) {
            this.postConfig(this.keys.get('MODE_TOGGLE'), false)
            this.peakModeManual = false
          } else {
            this.peakModeManual = manual === 'true' ? true : false
          }

          if (ceiling == null) {
            this.postConfig(this.keys.get('CEILING'), 0)
            this.ncpCeiling = 0
            this.ncpCeilingSwitch = false
          } else {
            let ncpc = parseInt(ceiling)
            this.ncpCeiling = ncpc
            if (ncpc === 0) {
              this.ncpCeilingSwitch = false
            } else {
              this.ncpCeilingSwitch = true
            }
          }
        }

        // **
        let defaultFactor = parseFloat(1.0).toFixed(4)
        if (this.hasProgram('1CP')) {
          if (adjust1cp == null) {
            this.postConfig(this.keys.get('1CP_FUDGE'), defaultFactor)
            this.adjustFactor1cp = defaultFactor
          } else {
            this.adjustFactor1cp = parseFloat(adjust1cp).toFixed(4)
          }

          if (thresh1cp == null) {
            this.postConfig(this.keys.get('1CP_THRESH'), defaultFactor)
            this.previousMinThres1cp = defaultFactor
          } else {
            this.previousMinThres1cp = parseFloat(thresh1cp).toFixed(4)
          }
        }

        // **
        if (this.hasProgram('5CP')) {
          if (adjust5cp == null) {
            this.postConfig(this.keys.get('5CP_FUDGE'), defaultFactor)
            this.adjustFactor5cp = defaultFactor
          } else {
            this.adjustFactor5cp = parseFloat(adjust5cp).toFixed(4)
          }

          if (thresh5cp == null) {
            this.postConfig(this.keys.get('5CP_THRESH'), defaultFactor)
            this.previousMinThres5cp = defaultFactor
          } else {
            this.previousMinThres5cp = parseFloat(thresh5cp).toFixed(4)
          }
        }

        // console.log('peakMode', this.peakMode)
        // console.log('peakModeManual', this.peakModeManual)
        // console.log('ncpCeiling', this.ncpCeiling)
        // console.log('adjustFactor1cp', this.adjustFactor1cp)
        // console.log('previousMinThres1cp', this.previousMinThres1cp)
        // console.log('adjustFactor5cp', this.adjustFactor5cp)
        // console.log('previousMinThres5cp', this.previousMinThres5cp)

        this.loaded = true
      } catch (err) {
        console.error(err)
      }
    },
    onSave(configType) {
      // console.log('peakMode', this.peakMode)
      // console.log('peakModeManual', this.peakModeManual)
      // console.log('ncpCeiling (0-100,000)', this.ncpCeiling)
      // console.log('adjustFactor1cp (0.1-1.99)', this.adjustFactor1cp)
      // console.log('previousMinThres1cp (0.1-1.99)', this.previousMinThres1cp)
      // console.log('adjustFactor5cp  (0.1-1.99)', this.adjustFactor5cp)
      // console.log('previousMinThres5cp (0.1-1.99)', this.previousMinThres5cp)

      if (configType === 'CP') {
        this.savePeakData()
      }
      // if (configType === 'GAS') {
      //   ...
      // }

      // this.getPeakConfig()
      this.$toast.success("Configuration successfully saved.")
      this.componentKey += 1
    },
    savePeakData() {
      if (this.hasProgram('NCP')) {
        this.postConfig(this.keys.get('MODE'), this.peakMode)
        this.postConfig(this.keys.get('MODE_TOGGLE'), this.peakModeManual)

        // check switch on before setting/saving
        if (!this.ncpCeilingSwitch) {
          this.ncpCeiling = 0
        }
        this.postConfig(this.keys.get('CEILING'), parseFloat(this.ncpCeiling))
        this.SET_NCP_CEILING({ ceiling: this.ncpCeiling })
      }

      if (this.hasProgram('1CP')) {
        this.postConfig(this.keys.get('1CP_FUDGE'), this.adjustFactor1cp)
        this.postConfig(this.keys.get('1CP_THRESH'), this.previousMinThres1cp)
      }

      if (this.hasProgram('5CP')) {
        this.postConfig(this.keys.get('5CP_FUDGE'), this.adjustFactor5cp)
        this.postConfig(this.keys.get('5CP_THRESH'), this.previousMinThres5cp)
      }
    },
    async getConfig(key) {
      try {
        let response = await ConfigService.getValue(key)
        if (response.data) {
          return response.data.value
        }
      } catch (error) {}
      return null
    },
    postConfig(key, value) {
      ConfigService.postValue(key, value)
          // .then(response => {})
          .catch(error => { this.$toast.error("Cannot post updates for key=" + key + " " + error.message) })
    }
  }
}
</script>
